import moment from 'moment';
import { first, split } from 'lodash';

function configureArabicJordanian() {
  const m = moment().locale('ar-JO');
  
  moment.updateLocale('ar-JO', {
    months: m.localeData()._months,
    monthsShort: m.localeData()._monthsShort,
  });
  
  moment().locale('ar-JO').localeData()._abbr = 'ar-JO';
}

configureArabicJordanian();

moment.fn.getLocalePrefix = function() {
  return first(split(this.locale(), '-'));
};

moment.fn.isEnglish = function() {
  return this.getLocalePrefix() === 'en';
};

moment.fn.isRussian = function() {
  return this.getLocalePrefix() === 'ru';
};

moment.fn.isArabic = function() {
  return this.getLocalePrefix() === 'ar';
};

moment.fn.toJSON = function () {
  return this.format();
};
